const SECTION_STATES = {
    customerInfo: [
        'Yeni Çağrı Formu',
        'Düzeltme Bekleniyor',
        'Çağrı Formu Reddedildi',
        'Müvekkil Reddedildi',
        'Taslak',
        'Vekalet Bekleniyor',
        'Eksper Onay Bekleniyor',
        'Yönetici Onay Bekleniyor',
        'Ödeme Bekleniyor',
        'Evrak Bekleniyor',
        'Eksper İşlem Bekleniyor',
        'Yeni Eksper İşlem Bekleniyor',
        'Eksper Rapor Bekleniyor',
        'Yeni Eksper Rapor Bekleniyor',
        'Eksper Raporu Ödeme Bekleniyor',
        'Yeni Eksper Raporu Ödeme Bekleniyor',
        'Sigorta Başvuru Dilekçe Bekleniyor',
        'Yeni Sigorta Başvuru Dilekçe Bekleniyor',
        'Ekspersiz Yeni Sigorta Başvuru Dilekçe Bekleniyor',
        'İcra Sürecine Yönlendirildi',
        'Tüm Form',
    ],
    contactInfo: [
        'Yeni Çağrı Formu',
        'Çağrı Formu Reddedildi',
        'Müvekkil Reddedildi',
        'Düzeltme Bekleniyor',
        'Taslak',
        'Vekalet Bekleniyor',
        'Eksper Onay Bekleniyor',
        'Yönetici Onay Bekleniyor',
        'Ödeme Bekleniyor',
        'Tüm Form',
    ],
    accidentInfo: [
        'Yeni Çağrı Formu',
        'Çağrı Formu Reddedildi',
        'Müvekkil Reddedildi',
        'Düzeltme Bekleniyor',
        'Taslak',
        'Vekalet Bekleniyor',
        'Eksper Onay Bekleniyor',
        'Yönetici Onay Bekleniyor',
        'Ödeme Bekleniyor',
        'Tüm Form',
    ],
    powerOfAttorney: ['Vekalet Bekleniyor', 'Tüm Form'],
    addressInfo: ['Vekalet Bekleniyor', 'Tüm Form'],
    documentRequest: ['Evrak Bekleniyor', 'Tüm Form'],
    expert: [
        'Eksper İşlem Bekleniyor',
        'Yeni Eksper İşlem Bekleniyor',
        'Eksper Rapor Bekleniyor',
        'Yeni Eksper Rapor Bekleniyor',
        'Eksper Raporu Ödeme Bekleniyor',
        'Yeni Eksper Raporu Ödeme Bekleniyor',
        'Sigorta Başvuru Dilekçe Bekleniyor',
        'Yeni Sigorta Başvuru Dilekçe Bekleniyor',
        'Ekspersiz Yeni Sigorta Başvuru Dilekçe Bekleniyor',
        'İcra Sürecine Yönlendirildi',
        'Tüm Form',
    ],
    expertReport: ['Eksper Rapor Bekleniyor', 'Yeni Eksper Rapor Bekleniyor', 'Tüm Form'],
    insuranceCompanyReport: [
        'Sigorta Başvuru Dilekçe Bekleniyor',
        'Yeni Sigorta Başvuru Dilekçe Bekleniyor',
        'Ekspersiz Yeni Sigorta Başvuru Dilekçe Bekleniyor',
        'Tüm Form',
    ],
    expenseCardList: ['Ödeme Bekleniyor', 'Tüm Form'],
    accidentFileExpenseList: ['Eksper Raporu Ödeme Bekleniyor', 'Yeni Eksper Raporu Ödeme Bekleniyor'],
};

export const getCallFormSectionVisibility = (currentFormState) => {
    const hasState = (sectionName) => SECTION_STATES[sectionName].includes(currentFormState);

    return {
        customerInfo: hasState('customerInfo'),
        contactInfo: hasState('contactInfo'),
        accidentInfo: hasState('accidentInfo'),
        powerOfAttorney: hasState('powerOfAttorney'),
        addressInfo: hasState('addressInfo'),
        documentRequest: hasState('documentRequest'),
        expert: hasState('expert'),
        expertReport: hasState('expertReport'),
        insuranceCompanyReport: hasState('insuranceCompanyReport'),
        expenseCardList: hasState('expenseCardList'),
        accidentFileExpenseList: hasState('accidentFileExpenseList'),
    };
};
